import { render, staticRenderFns } from "./employee-hris.vue?vue&type=template&id=090ca6f0&"
import script from "./employee-hris.vue?vue&type=script&lang=js&"
export * from "./employee-hris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports